import { DonutCard, IGNIS_RED } from "@120wateraudit/waterworks";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { CSSProperties } from "react";
import { Popup } from "semantic-ui-react";

interface Props {
  galvanized: number;
  lead: number;
  nonLead: number;
  style?: CSSProperties;
  unknown: number;
}

const MaterialsDonutCard = ({
  galvanized,
  lead,
  nonLead,
  style,
  unknown,
}: Props): null | JSX.Element => {
  return (
    <DonutCard
      style={{ height: "100%", ...style }}
      title="LIVE Data from PWS - Material Classification Breakdown"
      chartData={[
        {
          label: "Lead",
          color: IGNIS_RED,
          metric: { currentValue: lead },
        },
        {
          label: "GRR",
          color: "#FFC720",
          metric: { currentValue: galvanized },
        },
        {
          label: "Non-Lead",
          color: "#00B5E2",
          metric: { currentValue: nonLead },
        },
        {
          label: "Unknown",
          color: "#0033A0",
          metric: { currentValue: unknown },
        },
      ]}
      metricName="Total Service Lines"
      showAsPercentages={false}
      hideBottomMetricName
      dropdownComponent={
        <Popup
          trigger={
            <FontAwesomeIcon
              icon={faCircleQuestion}
              style={{ cursor: "pointer", color: "#707683", marginLeft: "8px" }}
            />
          }
          content="Service Lines reflected in this chart are LIVE Data in PWS and In-Service"
          position="top right"
        />
      }
    />
  );
};

export default MaterialsDonutCard;
